// GateCrashScreen.jsx -- fallback for a crash inside the onboarding gate. Single job: replace a lockout
// with a recovery screen and hand the error to `report` exactly once (the pre-consent crash beacon,
// or PostHog when consented).
import { useEffect, useRef } from 'react';
import { shell, headline, body, ghostBtn, spacer, C } from './onboardingStyles';
export default function GateCrashScreen({ error, step, onRetry, report }) {
  const sent = useRef(false);
  useEffect(() => {
    if (sent.current) return;
    sent.current = true;
    report(error, step);
  }, [error, step, report]);
  return (
    <div style={shell}>
      <div style={{ fontSize: 11, fontWeight: 800, letterSpacing: 4, color: C.dim }}>SLIPTRACK</div>
      <div style={{ marginTop: 72, display: 'flex', flexDirection: 'column', gap: 14 }}>
        <h1 style={headline}>Something went wrong</h1>
        <p style={body}>We've been notified. Try again, and if it keeps happening email hello@sliptrack.net.</p>
      </div>
      <div style={spacer} />
      <button type="button" style={ghostBtn} onClick={onRetry}>Try again</button>
    </div>
  );
}
